import colorPicker from './components/Sketch.vue';
const ColorPicker = {
    install: function (Vue, options) {
        Vue.component('colorPicker', colorPicker);
    },
};
if (window.Vue) {
    window.Vue.use(ColorPicker);
}
export default ColorPicker;
